import Confetti from 'react-confetti';
import { AspectBackgroundVideo_ } from './AspectBackgroundVideo_';
import { RareInputMask } from '../areas/InputMask/components/RareInputMask';
export class RareComponents {
    Confetti = Confetti;
    AspectBackgroundVideo_ = AspectBackgroundVideo_;
    RareInputMask = RareInputMask;
}
